import React, { useState } from "react";
import { motion } from "framer-motion";

export default function CampoRelatoSolucao({
  relato,
  setRelato,
  solucao,
  setSolucao,
}) {
  const [expandRelato, setExpandRelato] = useState(false);
  const [expandSolucao, setExpandSolucao] = useState(false);

  const textareaBaseClasses = `
    peer w-full border border-gray-300 rounded
    px-3 pt-4 pb-1.5 text-base text-gray-900
    focus:border-blue-600 focus:ring-0 focus:outline-none
    bg-transparent placeholder-transparent resize-none
    transition-all
  `;

  const labelBaseClasses = (value) => `
    absolute left-3 transition-all duration-200 pointer-events-none
    ${
      value && value.length > 0
        ? "-top-2 text-sm font-bold text-gray-900 bg-white px-1"
        : "top-2 text-base text-gray-400"
    }
    peer-focus:-top-2 peer-focus:text-sm peer-focus:font-bold peer-focus:text-gray-900 peer-focus:bg-white peer-focus:px-1
  `;

  return (
    <div className="flex flex-col gap-6 mb-4">
      {/* Relato do Problema */}
      <div className="relative">
        <motion.textarea
          value={relato}
          onChange={(e) => setRelato(e.target.value)}
          placeholder=" "
          className={textareaBaseClasses}
          initial={false}
          animate={{ height: expandRelato ? 240 : 100 }}
          transition={{ duration: 0.4, ease: "easeInOut" }}
        />
        <label className={labelBaseClasses(relato)}>Relato do Problema</label>
        <button
          type="button"
          className="text-blue-600 text-sm mt-1 underline"
          onClick={() => setExpandRelato((prev) => !prev)}
        >
          {expandRelato ? "Ver menos" : "Ver mais"}
        </button>
      </div>

      {/* Solução do Problema */}
      <div className="relative">
        <motion.textarea
          value={solucao}
          onChange={(e) => setSolucao(e.target.value)}
          placeholder=" "
          className={textareaBaseClasses}
          initial={false}
          animate={{ height: expandSolucao ? 240 : 100 }}
          transition={{ duration: 0.4, ease: "easeInOut" }}
        />
        <label className={labelBaseClasses(solucao)}>Solução do Problema</label>
        <button
          type="button"
          className="text-blue-600 text-sm mt-1 underline"
          onClick={() => setExpandSolucao((prev) => !prev)}
        >
          {expandSolucao ? "Ver menos" : "Ver mais"}
        </button>
      </div>
    </div>
  );
}
